import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'

import QuickMessage from '@/models/quickMessage'
import api from '@/shared/api'
import { ENDPOINTS } from '@/shared/constants'

interface QuickMessagesState {
  quickMessages: QuickMessage[]
  loading: boolean
  error: string | null
}

// Estado inicial
const initialState: QuickMessagesState = {
  quickMessages: [],
  loading: false,
  error: null,
}

// Função para buscar itens da API
export const fetchQuickMessages = createAsyncThunk<QuickMessage[]>(
  'quickMessages/fetchQuickMessages',
  async (_, thunkAPI) => {
    try {
      const response = await api.get(
        ENDPOINTS.QUICK_MESSAGES.GET.FOR_CONVERSATIONS
      )

      return (await response.data) as QuickMessage[]
    } catch (error: unknown) {
      toast.error('Erro ao listar mensagens rápidas')
      let errorMessage = 'Unknown error'

      if (error instanceof Error) {
        errorMessage = error.message
      }

      return thunkAPI.rejectWithValue(errorMessage)
    }
  }
)

// Slice
const quickMessagesSlice = createSlice({
  name: 'quickMessages',
  initialState,
  reducers: {
    // Exemplo de reducer adicional, se necessário
    clearError(state) {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuickMessages.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        fetchQuickMessages.fulfilled,
        (state, action: PayloadAction<QuickMessage[]>) => {
          state.loading = false
          state.quickMessages = action.payload
        }
      )
      .addCase(fetchQuickMessages.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

// Exporta ações e reducer
export const { clearError } = quickMessagesSlice.actions
export default quickMessagesSlice.reducer
